export default "__VITE_ASSET__CunVgYsq__"